import styled from "styled-components";

export const MenuItemsWrapper = styled.div`
`;